import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { menuToggler } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  display: flex;
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

function ToggleNavAreaLinks({
  areas, isActiveMenu, activateMenu }) {
  return (
    <div className={styles}>
      {
        areas.filter(area => area.isMetro).map(metro => (
          <div className="ToggleNav_menuItem" key={get(metro, 'name')}>
            <span
              className="ToggleNav_menuHeading"
              role="button"
              tabIndex="0"
              onClick={activateMenu(metro.name)}
            >
              {metro.name}
            </span>
            <ul className={`${isActiveMenu(metro.name) ? 'ToggleNav_subMenu-active' : ''} ToggleNav_subMenu`}>
              <li className="ToggleNav_subMenuItem"><Link name="communities" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Communities</Link></li>
              <li className="ToggleNav_subMenuItem"><Link name="homes" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Available Homes</Link></li>
              {
                areas.filter(area => area.parentMetro === metro.name).map(submetro => (
                  <li key={submetro.name} className="ToggleNav_subMenuItem">
                    <Link
                      name="communities"
                      params={{
                        communityMarketAreaMetro: get(metro, 'name'),
                        communityMarketAreaSubMetro: get(submetro, 'name'),
                      }}
                    >
                      {submetro.name} New Homes
                    </Link>
                  </li>
                ))
              }
              {
                metro.name === 'California' &&
                <li className="ToggleNav_subMenuItem"><Link name="elliott-reserve">Turnkey Custom Homes</Link></li>
              }
            </ul>
          </div>
        ))
      }
    </div>
  );
}

ToggleNavAreaLinks.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
};

ToggleNavAreaLinks.defaultProps = {
  submetroMenu: false,
};

export default withData(
  {
    areas: true,
  },
)(menuToggler((ToggleNavAreaLinks)));



// WEBPACK FOOTER //
// ./src/components/Header/ToggleNavAreaLinks.js